export default global.LitiumConstants;

export const ViewMode = {
  List: 'list',
  Edit: 'edit',
  Detail: 'detail',
};

export const PaginationOptions = {
  PageSize: 10, // Number of items per page
  DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
  EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_SET_GENERAL_ROW_NOTE = 'CART_SET_GENERAL_ROW_NOTE';
export const CART_ADD_TO_CART_ANIMATION = 'CART_ADD_TO_CART_ANIMATION';

export const OFFER_LOAD_ERROR = 'OFFER_LOAD_ERROR';
export const OFFERS_RECEIVE = 'OFFERS_RECEIVE';
export const OFFERS_SHOW_OFFER_MENU = 'OFFERS_SHOW_OFFER_MENU';
export const OFFERS_SET_ACTIVE = 'OFFERS_SET_ACTIVE';
export const OFFERS_ON_OFFER_CLICKED = 'OFFERS_ON_OFFER_CLICKED';

export const CHECKOUT_UPDATE_ADDRESS = 'CHECKOUT_UPDATE_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_NEWSLETTER_OPT_IN = 'CHECKOUT_SET_NEWSLETTER_OPT_IN';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_USED_DISCOUNT_CODE =
  'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
  'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS =
    'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON =
    'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACET_FILTERS_CHANGED = 'FACET_FILTERS_CHANGED';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE =
  'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';

export const CONTACT_US_MODAL_SHOW = 'CONTACT_US_MODAL_SHOW';

export const LOGIN_MODAL_SHOW = 'LOGIN_MODAL_SHOW';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW = 'QUICK_SEARCH_SHOW';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';
export const ORDER_SET_IS_LOADING = 'ORDER_SET_IS_LOADING';
export const ORDER_SET_SEARCH_WORD = 'ORDER_SET_SEARCH_WORD';
export const ORDER_SET_FROM_DATE = 'ORDER_SET_FROM_DATE';
export const ORDER_SET_TO_DATE = 'ORDER_SET_TO_DATE';

export const QUICK_ORDER_QUERY = 'QUICK_ORDER_QUERY';
export const QUICK_ORDER_RECEIVE = 'QUICK_ORDER_RECEIVE';
export const QUICK_ORDER_ERROR = 'QUICK_ORDER_ERROR';
export const QUICK_ORDER_IS_LOADING = 'QUICK_ORDER_IS_LOADING';
export const QUICK_ORDER_IS_AUTO_COMPLETE_LOADING =
  'QUICK_ORDER_IS_AUTO_COMPLETE_LOADING';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';

export const ADVANCED_SEARCH_ERROR = 'ADVANCED_SEARCH_ERROR';
export const ADVANCED_SEARCH_RECEIVE_CAR_MODEL =
  'ADVANCED_SEARCH_RECEIVE_CAR_MODEL';
export const ADVANCED_SEARCH_UPDATE_PAYLOAD = 'ADVANCED_SEARCH_UPDATE_PAYLOAD';
export const ADVANCED_SEARCH_DIMENSIONS = 'ADVANCED_SEARCH_DIMENSIONS';
export const ADVANCED_SEARCH_SEARCH_TYPE_DIMENSION = 'DIMENSION';
export const ADVANCED_SEARCH_SEARCH_TYPE_CARMODEL = 'CARMODEL';
export const ADVANCED_SEARCH_SEARCH_TYPE_REGNO = 'REGNO';
export const ADVANCED_SEARCH_REAR_DIMENSION_QUERY =
  'ADVANCED_SEARCH_REAR_DIMENSION_QUERY';
export const ADVANCED_SEARCH_SET_IS_LOADING_URL =
  'ADVANCED_SEARCH_SET_IS_LOADING_URL';

export const PRODUCTS_SET_LIST_TYPE = 'PRODUCTS_SET_LIST_TYPE';
export const PRODUCTS_RECEIVE_PRODUCTS_WRAPPER =
  'PRODUCTS_RECEIVE_PRODUCTS_WRAPPER';
export const PRODUCTS_SET_IS_LOADING = 'PRODUCTS_SET_IS_LOADING';
export const PRODUCTS_SET_HAS_REAR_PRODUCTS = 'PRODUCTS_SET_HAS_REAR_PRODUCTS';

export const WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL =
  'WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL';
export const WHEELBUILDER_RECEIVE_ERROR = 'WHEELBUILDER_RECEIVE_ERROR';
export const WHEELBUILDER_SET_SELECTED_RIM = 'WHEELBUILDER_SET_SELECTED_RIM';
export const WHEELBUILDER_SET_SELECTED_RIM_QUANTITY =
  'WHEELBUILDER_SET_SELECTED_RIM_QUANTITY';
export const WHEELBUILDER_RECEIVE_TIRES = 'WHEELBUILDER_RECEIVE_TIRES';
export const WHEELBUILDER_SET_SELECTED_PRODUCT =
  'WHEELBUILDER_SET_SELECTED_PRODUCT';
export const WHEELBUILDER_SET_CURRENT_STEP = 'WHEELBUILDER_SET_CURRENT_STEP';
export const WHEELBUILDER_SET_PRODUCT_QUANTITY =
  'WHEELBUILDER_SET_PRODUCT_QUANTITY';
export const WHEELBUILDER_RECEIVE_TPMS_SENSORS =
  'WHEELBUILDER_RECEIVE_TPMS_SENSORS';
export const WHEELBUILDER_SET_IS_LOADING = 'WHEELBUILDER_SET_IS_LOADING';
export const WHEELBUILDER_RESET_REGNO_STEP = 'WHEELBUILDER_RESET_REGNO_STEP';
export const WHEELBUILDER_RECEIVE_SUMMARY = 'WHEELBUILDER_RECEIVE_SUMMARY';
export const WHEELBUILDER_SET_ASSEMBLY_CHECKED =
  'WHEELBUILDER_SET_ASSEMBLY_CHECKED';
export const WHEELBUILDER_RECEIVE_PAYLOAD = 'WHEELBUILDER_RECEIVE_PAYLOAD';
export const WHEELBUILDER_SET_PAGINATION = 'WHEELBUILDER_SET_PAGINATION';
export const WHEELBUILDER_SET_BLACK_VALVE_CHECKED =
  'WHEELBUILDER_SET_BLACK_VALVE_CHECKED';

export const CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN =
  'CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN';
export const CAR_PREVIEW_RECEIVE_PREVIEW_MODEL =
  'CAR_PREVIEW_RECEIVE_PREVIEW_MODEL';

export const PRICE_MARGINS_RECEIVE_ALL_RULES =
  'PRICE_MARGINS_RECEIVE_ALL_RULES';
export const PRICE_MARGINS_RECEIVE_RULE = 'PRICE_MARGINS_RECEIVE_RULE';
export const PRICE_MARGINS_SET_ERROR = 'PRICE_MARGINS_SET_ERROR';
export const PRICE_MARGINS_REMOVE_RULE = 'PRICE_MARGINS_REMOVE_RULE';
export const PRICE_MARGINS_RECEIVE_FILTERS = 'PRICE_MARGINS_RECEIVE_FILTERS';
export const PRICE_MARGINS_RECEIVE_CATEGORIES =
  'PRICE_MARGINS_RECEIVE_CATEGORIES';
export const PRICE_MARGINS_RECEIVE_VALUE = 'PRICE_MARGINS_RECEIVE_VALUE';
export const PRICE_MARGINS_SET_FILTER_VALUE = 'PRICE_MARGINS_SET_FILTER_VALUE';
export const PRICE_MARGINS_RESET_FORM = 'PRICE_MARGINS_RESET_FORM';
export const PRICE_MARGINS_SET_IS_LOADING = 'PRICE_MARGINS_SET_IS_LOADING';
export const PRICE_MARGINS_SET_INFO_TEXT = 'PRICE_MARGINS_SET_INFO_TEXT';

export const MY_PAGES_DETAILS = 'MY_PAGES_DETAILS';
export const MY_PAGES_INVOICES = 'MY_PAGES_INVOICES';
export const MY_PAGES_ORDER_HISTORY = 'MY_PAGES_ORDER_HISTORY';
export const MY_PAGES_MARGINS = 'MY_PAGES_MARGINS';
export const MY_PAGES_USERS = 'MY_PAGES_USERS';
export const MY_PAGES_SET_ACTIVE_TAB = 'MY_PAGES_SET_ACTIVE_TAB';
export const MY_PAGES_SHOW_DROPDOWN = 'MY_PAGES_SHOW_DROPDOWN';

export const OVERLAY_ADD_OVERLAY = 'OVERLAY_ADD_OVERLAY';
export const OVERLAY_REMOVE_OVERLAY = 'OVERLAY_REMOVE_OVERLAY';
export const OVERLAY_CLOSE_OVERLAY = 'OVERLAY_CLOSE_OVERLAY';
export const OVERLAY_UPDATE_OVERLAY = 'OVERLAY_UPDATE_OVERLAY';

export const PRICE_DISPLAY_QUANTITY_SET = 'PRICE_DISPLAY_QUANTITY_SET';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';
